import { createActions, createReducer } from "reduxsauce"

const { Types, Creators } = createActions({
  getServices: [],
  getCategoryServices: ["subCategoryId"],
  getCompanyServices: ["companyId"],
  setCompanyServices: ["companyServices"],
  setServices: ["services"],
  setSubCategories: ["subCategories"],
  toggleOverview: ["showOverview"],
  togglePopUp: ["isShowing"],
  setAccount: ["activeAccount"],
  setUsers: ["userList"],
  setSkinUsers: ["skinUserList"],
  setUsersSimple: ["userListSimple"],
  getUsers: [
    "search_user",
    "skin_id",
    "limit",
    "page_number",
    "LOAD_FALSE",
    "username",
    "ragione_sociale",
    "city",
    "user_id",
    "credito",
    "from_last_login",
    "to_last_login",
  ],
  getSkinUsers: ["skin_id"],
  getUsersSimple: [],
  getUsersBySearch: ["search_user"],
  setUsersBySearch: ["userListBySearch"],
  getOverviewDashboard: ["period"],
  setOverviewDashboard: ["dashboardData"],
  setSystemModes: ["systemModes"],
  setNavbarSearch: ["navbarSearch"],
  setScreenW: ["screenWidth"],
  setFavorites: ["favorites"],
  getFavorites: [],
  toggleFavorite: ["id", "sType", "companyId"],
  updateSystemMode: ["sysmode", "password"],
  setActiveSkinId: ["activeSkinId"],
  setActiveSkinName: ["activeSkinName"],
  setLoaderForAdminUtenti: ["LoaderAU"],
  getUserPhotos: ["id"],
  getSystemModes: [],
  setPhotoLoading: ["photoLoading"],
  setUserPhotos: ["userPhotos"],
  getSearchedUsers: ["search_user"],
  sendPrenotazione: ["objectData", "resetState"],
  forgotPassword: ["email"],
  setAdminMessagesModal: ["adminMessagesModal"],
  getRegisterToken: ["agency_id", "callBack"],
  getSelectedCompany: ["service_id", "listino_id"],
  setSelectedCompany: ["selectedCompany"],
  getAllImages: ["group"],
  setAllImages: ["images"],
  uploadNewImage: ["fileList", "group"],
  updateImage: ["id", "name", "group", "image"],
  deleteImage: ["id"],
  updateCompany: [
    "id",
    "logo",
    "backgroundImage",
    "icon",
    "logoScontrino",
    "colorBg",
    "colorTesto",
    "services",
    "content",
    "content_scontrino",
    "is_percentage",
    "services_as_company",
    "setLoading",
    "listino_id",
  ],
  getServicesData: [],
  setServicesData: ["servicesData"],
  getServicesTree: [],
  setServicesTree: ["servicesTree"],
  changeServiceCategory: ["companyId", "categoryId"],
  updateServiceName: ["id", "name", "setLoading"],
  getProviders: [],
  setProviders: ["providers"],
  createProvider: [
    "name",
    "wallet",
    "status",
    "url",
    "username",
    "password",
    "setLoading",
    "closeModal",
  ],
  updateProvider: [
    "name",
    "wallet",
    "status",
    "url",
    "username",
    "password",
    "id",
    "setLoading",
    "closeModal",
  ],
  getListinoList: [],
  setListinoList: ["listinoList"],
  createListino: ["name", "description", "listino_id", "setLoading", "closeModal"],
  getSingleListino: ["id"],
  updateListino: ["name", "status", "description", "id", "setLoading", "closeModal"],
  refund: ["barcode"],
  cancel: ["payment_id", "nome_operatore", "description"],
  allowPayWithAdyen: ["company_id"],
  updateAdyenAllow: ["id", "listinoId", "all", "service_id"],
  getStatistics: ["group_by", "start_date", "end_date", "setLoading", "skin_id"],
  setStats: ["stats"],
  updateUserType: ["user_id", "new_type"],
  getPendingPayments: ["page", "limit"],
  setPendingPayments: ["pendingPayments"],
  connectFintech: ["iban", "asp_code", "codice_fiscale", "name", "surname", "partita_iva","denominazione", "tipoSocietario", "setLoading"],
  setFintechUrl: ["fintechUrl"],
  getFintechAccounts: ["page", "per_page"],
  setFintechAccounts: ["fintechAccounts"],
  updateFintechAccount: ["account_id"]
})

export const MainTypes = Types
export default Creators

const INITIAL_STATE = {
  photoLoading: false,
  userPhotos: {},
  favorites: [],
  services: {},
  showOverview: true,
  isShowing: false,
  activeAccount: 2,
  userList: [],
  skinUserList: [],
  userListSimple: [],
  userListBySearch: [],
  dashboardData: {},
  systemModes: [],
  navbarSearch: "",
  activeSkinId: -1,
  activeSkinName: "",
  screenWidth: window.innerWidth,
  LoaderAU: false,
  adminMessagesModal: false,
  selectedCompany: {},
  images: [],
  servicesData: [],
  servicesTree: [],
  providers: [],
  companyServices: [],
  subCategories: {},
  listinoList: [],
  stats: {},
  pendingPayments: [],
  fintechUrl: "",
  fintechAccounts: []
}

export const reducer = createReducer(INITIAL_STATE, {
  SET_ADMIN_MESSAGES_MODAL: (state) => ({
    ...state,
    adminMessagesModal: !state.adminMessagesModal,
  }),
  SET_PHOTO_LOADING: (state, payload) => {
    return {
      ...state,
      photoLoading: payload.photoLoading,
    }
  },
  SET_USER_PHOTOS: (state, { userPhotos }) => ({
    ...state,
    userPhotos,
  }),
  SET_FAVORITES: (state, { favorites }) => ({
    ...state,
    favorites,
  }),
  SET_NAVBAR_SEARCH: (state, { navbarSearch }) => ({
    ...state,
    navbarSearch,
  }),
  SET_SCREEN_W: (state, { screenWidth }) => ({
    ...state,
    screenWidth,
  }),
  SET_OVERVIEW_DASHBOARD: (state, { dashboardData }) => ({
    ...state,
    dashboardData,
  }),
  SET_SYSTEM_MODES: (state, { systemModes }) => ({
    ...state,
    systemModes,
  }),
  TOGGLE_OVERVIEW: (state, { showOverview }) => ({
    ...state,
    showOverview,
  }),
  SET_ACCOUNT: (state, { activeAccount }) => ({
    ...state,
    activeAccount,
  }),
  SET_SERVICES: (state, { services }) => ({
    ...state,
    services,
  }),
  SET_SUB_CATEGORIES: (state, { subCategories }) => ({
    ...state,
    subCategories,
  }),
  SET_USERS: (state, { userList }) => ({
    ...state,
    userList,
  }),
  SET_SKIN_USERS: (state, { skinUserList }) => ({
    ...state,
    skinUserList,
  }),
  SET_USERS_SIMPLE: (state, { userListSimple }) => ({
    ...state,
    userListSimple,
  }),
  SET_USERS_BY_SEARCH: (state, { userListBySearch }) => ({
    ...state,
    userListBySearch,
  }),
  TOGGLE_POP_UP: (state, { isShowing }) => ({
    ...state,
    isShowing,
  }),
  SET_ACTIVE_SKIN_ID: (state, { activeSkinId }) => ({
    ...state,
    activeSkinId,
  }),
  SET_ACTIVE_SKIN_NAME: (state, { activeSkinName }) => ({
    ...state,
    activeSkinName,
  }),
  SET_LOADER_FOR_ADMIN_UTENTI: (state, { LoaderAU }) => ({
    ...state,
    LoaderAU,
  }),
  SET_SELECTED_COMPANY: (state, { selectedCompany }) => ({
    ...state,
    selectedCompany,
  }),
  SET_ALL_IMAGES: (state, { images }) => ({
    ...state,
    images,
  }),
  SET_SERVICES_DATA: (state, { servicesData }) => ({
    ...state,
    servicesData,
  }),
  SET_SERVICES_TREE: (state, { servicesTree }) => ({
    ...state,
    servicesTree,
  }),
  SET_PROVIDERS: (state, { providers }) => ({
    ...state,
    providers,
  }),
  SET_COMPANY_SERVICES: (state, { companyServices }) => ({
    ...state,
    companyServices,
  }),
  SET_LISTINO_LIST: (state, { listinoList }) => ({
    ...state,
    listinoList,
  }),
  SET_STATS: (state, { stats }) => ({
    ...state,
    stats,
  }),
  SET_PENDING_PAYMENTS: (state, { pendingPayments }) => ({
    ...state,
    pendingPayments,
  }),
  SET_FINTECH_URL: (state, { fintechUrl }) => ({
    ...state,
    fintechUrl,
  }),
   SET_FINTECH_ACCOUNTS: (state, { fintechAccounts}) => ({
    ...state,
    fintechAccounts,
  }),
})
